<template>
    <div id="chart-container" class="chart-center">
        <div id="transactions_id" style="height: 500px; width: 1000px;"></div>

        <div class="buttons" style="text-align: right;">
            <v-btn id="minute">Per minute</v-btn>
            <v-btn id="hour">Per hour</v-btn>
        </div>

        <div id="rba_id" style="height: 500px; width: 1000px;"></div>
    </div>
</template>

<script>

    import { mapState } from "vuex";
    import { LOAD_TRANSACTIONS } from "@/store/_actiontypes";
    import * as echarts from "echarts";

    export default {

        chart_t: {},
        chart_rba: {},

        data: () => ({
            loading: false,
            data_t: [],
            data_rba: [],
            timer: undefined,
            option: null,
            values: [],
            values_h: []
        }),

        computed: {

            ...mapState({ loglist: (state) => state.transactions.transactionlist }),
            ...mapState("responsecodes", ["responsecodelist"]),
            ...mapState({ ruleslist: (state) => state.rulesbyamount.ruleslist }),

            generateAllMinutesArray() {
                const timestamps = this.loglist.map(transaction => new Date(transaction.date));
                const startTime = new Date(Math.min(...timestamps));
                const endTime = new Date(Math.max(...timestamps));

                let allMinutes = [];
                const current = new Date(startTime);

                const newDate =new Date();
                newDate.setHours(newDate.getHours() - 1);

                while (current <= endTime) {
                    
                    const localTime = current.toLocaleTimeString('en-US', { hour12: false });

                    if (newDate <= current)
                        allMinutes.push(localTime.slice(0, 5));

                    current.setMinutes(current.getMinutes() + 1);
                }
                allMinutes = [...new Set(allMinutes)];
                console.log(startTime);
                console.log(newDate);
                console.log(endTime);
                console.log(allMinutes);
                return allMinutes.sort();
            },

            generateAllHoursArray() {
                const timestamps = this.loglist.map(transaction => new Date(transaction.date));
                const startTime = new Date(Math.min(...timestamps));
                const endTime = new Date(Math.max(...timestamps));

                let allMinutes = [];
                const current = new Date(startTime);
                while (current <= endTime) {
                    const localTime = current.toLocaleTimeString('en-US', { hour12: false });
                    allMinutes.push(localTime.slice(0, 2));
                    current.setHours(current.getHours() + 1);
                }
                allMinutes = [...new Set(allMinutes)];
               return allMinutes.sort();
            },

            items_t() {
                const minuteCounts = {};
                for (const transaction of this.loglist) {
                    const timestamp = transaction.date;
                    console.log(timestamp);

                    const minute = timestamp.split(" ")[1].split(":").slice(0, 2).join(":");// Extract minute part
                    if (!minuteCounts[minute]) {
                        minuteCounts[minute] = 0;
                    }
                    minuteCounts[minute]++;
                }
                return minuteCounts;
            },

            items_h() {
                const minuteCounts = {};
                for (const transaction of this.loglist) {
                    const timestamp = transaction.date;
                    const minute = timestamp.split(" ")[1].split(":").slice(0, 1);
                    if (!minuteCounts[minute]) {
                        minuteCounts[minute] = 0;
                    }
                    minuteCounts[minute]++;
                }
                return minuteCounts;
            },

            items_rba() {

                const itemCountMap = new Map();
                console.log(this.ruleslist)
                this.ruleslist.forEach((item) => {
                    const name = item.name.toString();
                    const currentCount = itemCountMap.get(name) || 0;
                    itemCountMap.set(name, currentCount + item.amount);
                });

                var resulting = [];
                for (let [key, value] of itemCountMap) {
                    resulting.push({ value: value, name: key });
                }
                return resulting;
            },
        },

        async created() {
            this.loadData();
            this.fetchLogList();
            this.fetchRulesList();
            this.minutes();
            this.hours();
            this.timer = setInterval(this.fetchLogList(), 100);
        },

        methods: {
            async loadData() {
                this.loading = true;
                this.$store.dispatch(`transactions/${LOAD_TRANSACTIONS}`);
                this.loading = false;
            },

            updateChartData() {
                this.data_t = this.items_t;
                this.data_rba = this.items_rba;
            },

            hours() {
                if (this.option != null) {
                    if (this.option.series[0].name == 'Minute') {
                        this.option.xAxis[0].data = this.generateAllHoursArray;
                        this.option.xAxis[0].axisLabel.interval = 0;
                        this.option.xAxis[0].axisLabel.rotate = 0;
                        this.option.legend.data = ["Hour"]
                        this.option.series[0].name = "Hour"
                        this.option.series[0].type = "bar";
                        this.option.series[0].name = "Hour";
                        this.option.series[0].data = this.values_h;
                    }
                    // Set the updated chart options
                    this.chart_t.setOption(this.option);
                }
            },

            minutes() {
                if (this.option != null) {
                    if (this.option.series[0].name == 'Hour') {
                        this.option.xAxis[0].data = this.generateAllMinutesArray;
                        this.option.xAxis[0].axisLabel.interval = 11;
                        this.option.xAxis[0].axisLabel.rotate = 30;
                        this.option.legend.data = ["Minute"]
                        this.option.series[0].name = "Minute"
                        this.option.series[0].type = "bar";
                        this.option.series[0].name = "Minute";
                        this.option.series[0].data = this.values;
                    }
                    // Set the updated chart options
                    this.chart_t.setOption(this.option);
                }
            },

            Init: function () {
                window.addEventListener('resize', function () {
                    this.chart_t.resize(), this.chart_rba.resize()
                }.bind(this))
            },

            fetchRulesList() {
                setTimeout(() => {
                    this.updateChartData();
                    console.log(this.data_rba);
                    var isDarkMode;
                    if (this.$vuetify.theme.global.name == "dark") {
                        isDarkMode = "#de3170";
                    } else {
                        isDarkMode = "#1e88e5";
                    }

                    this.chart_rba.setOption({
                        width: '100%',
                        tooltip: {
                            trigger: 'item'
                        },

                        title: {
                            text: 'Rules by amount',
                            x: 'center',
                            top: '20%',
                            textStyle: {
                                color: isDarkMode
                            }
                        },

                        legend: {
                            orient: 'vertical',
                            top: 'center',
                            right: '3',
                            textStyle: {
                                color: 'primary'
                            }
                        },

                        series: [{
                            top: '40%',
                            name: 'Rules by amount',
                            type: 'pie',
                            radius: ["30%", "100%"],
                            data: this.data_rba,
                            avoidLabelOverlap: true,
                            colorBy: 'data',
                            label: {
                                show: true,
                                color: isDarkMode
                            },
                        }],
                    })
                }, 200);
            },

            fetchLogList() {
                //this.data_t = this.items_t;
                setTimeout(() => {
                    this.updateChartData();
                    var minutes = this.generateAllMinutesArray;
                    var hours = this.generateAllHoursArray;

                    var minuteCounts = this.items_t;
                    var hourCounts = this.items_h;

                    this.values = minutes.map(minute => minuteCounts[minute] || 0);
                    this.values_h = hours.map(hour => hourCounts[hour] || 0);

                    var isDarkMode;
                    if (this.$vuetify.theme.global.name == "dark") {
                        isDarkMode = "#de3170";
                    } else {
                        isDarkMode = "#1e88e5";
                    }

                    this.option = ({
                        width: '100%',
                        tooltip: {
                            trigger: 'axis'
                        },

                        legend: {
                            data: ['Hour'],
                            selectedMode: 'single',
                            textStyle: {
                                color: isDarkMode
                            }
                        },

                        toolbox: {
                            show: true,
                            feature: {
                                dataView: { readOnly: false },
                                restore: {},
                                saveAsImage: {}
                            }
                        },

                        title: {
                            text: 'Transactions',
                            textStyle: {
                                color: isDarkMode
                            }
                        },

                        xAxis: [{
                            data: this.generateAllHoursArray,
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: isDarkMode
                                },
                            },
                            axisLabel: {
                                show: true,
                                interval: 0,
                                rotate: 0,
                            },
                            position: 'bottom'
                        },

                        ],

                        yAxis: [{
                            axisLine: {
                                lineStyle: {
                                    color: isDarkMode
                                }
                            }
                        },
                        ],

                        grid: {
                            bottom: 100,
                            containLabel: true
                        },

                        series: [{
                            name: 'Hour',
                            width: '100%',
                            type: 'bar',
                            stack: 'Total',

                            data: this.values_h,
                            color: isDarkMode,
                            label: {
                                color: isDarkMode
                            },
                            xAxisIndex: 0,
                        }]
                    })
                    this.chart_t.setOption(this.option)
                }, 200);

            },
        },

        stopTimer() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = undefined;
            }
        },

        beforeUnmount() {
            console.log("beforeUnmount");
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = undefined;
            }
        },


        mounted() {

            this.$nextTick(() => {
                document.getElementById('minute').addEventListener('click', this.minutes);
                document.getElementById('hour').addEventListener('click', this.hours);
            });

            this.chart_t = echarts.init(document.getElementById("transactions_id"));
            this.fetchLogList();
            this.minutes();
            this.hours();
            this.data_t = this.items_t;
            this.chart_rba = echarts.init(document.getElementById("rba_id"));
            this.fetchRulesList();
            this.data_rba = this.items_rba;
            let optionData = {};
            this.chart_rba.setOption(optionData)

            this.Init();
        }
    }


</script>

<style>
    .chart-center {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    button {
        margin-left: 50px;
    }
</style>